const selectAlgorithmCurrentValues = state => state.algorithm.currentValues;

export default {selectAlgorithmCurrentValues};